import { errorNetworkIn } from "../../logging/logging";
export var decodeLengthPrefix = function (value, TypeResponse, decodeCommand) {
    var protoPayload = new Uint8Array(value, 4);
    var dv = new DataView(value);
    var commandId = dv.getInt32(0);
    try {
        // As any cast required to be able to cast decoded value to TResponseWrapper
        var decodedWrapper = TypeResponse.decode(protoPayload);
        return decodeCommand(commandId, decodedWrapper);
    }
    catch (err) {
        // TODO: handle errors while decoding message
        errorNetworkIn("Error when decoding the message:", err);
    }
    return {
        id: commandId,
        props: undefined,
        sequenceNumber: -1,
        statusCode: -1,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/network/decoder/decodeLengthPrefix.ts
// module id = 2987
// module chunks = 3